import React, { useEffect, useState } from "react";
import Main from "../../../layout/main/Main";
import { Link, useSearchParams } from "react-router-dom";
import {
	ButtonContainer,
	ChildrenContainer,
	AntdButton,
	PageContainer,
	PageHeaderBlock,
	TitleBlock,
	PageTitle,
	PageSub,
	ContentShell,
} from "./styles";
import MegaDistributorList from "./megaDistributor/list/MegaDistributorList";
import LaboratoriesList from "./laboratories/list/LaboratoriesList";

export default function IndexPage() {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [filter, setFilter] = useState("DISTRIBUTORS");

	const get_filter = () => {
		setFilter(
			localStorage.getItem("indexFilter")
				? localStorage.getItem("indexFilter")
				: "DISTRIBUTORS",
		);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		get_filter();
	}, []);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to={"/" + uri}>Configuración General</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Distribuidores y Laboratorios
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<PageContainer>
					<PageHeaderBlock>
						<TitleBlock>
							<PageTitle>
								{filter === "DISTRIBUTORS" ? "Distribuidores" : "Laboratorios"}
							</PageTitle>
							<PageSub>
								{filter === "DISTRIBUTORS"
									? "Gestiona la configuracion de los distribuidores del sistema"
									: "Gestiona la asignacion de distribuidores a los laboratorios"}
							</PageSub>
						</TitleBlock>

						<ButtonContainer>
							<AntdButton
								$active={filter === "DISTRIBUTORS"}
								onClick={() => setFilter("DISTRIBUTORS")}
							>
								DISTRIBUIDORES
							</AntdButton>

							<AntdButton
								$active={filter === "LABORATORIES"}
								onClick={() => setFilter("LABORATORIES")}
							>
								LABORATORIOS
							</AntdButton>
						</ButtonContainer>
					</PageHeaderBlock>

					<ContentShell>
						<ChildrenContainer>
							{filter === "DISTRIBUTORS" && <MegaDistributorList uri={uri} />}
							{filter === "LABORATORIES" && <LaboratoriesList uri={uri} />}
						</ChildrenContainer>
					</ContentShell>
				</PageContainer>
			</Main.Body>
		</Main>
	);
}
